import { getInterval, getPeriodDateBoundsForInterval, groupByPeriod } from '@workalizer/shared/utils';
import { addDays, endOfDay, format, startOfDay } from 'date-fns';
function barDurationMinutes(startTime, endTime) {
    var toMin = function (t) {
        var _a = t.split(':').map(Number), h = _a[0], m = _a[1];
        return h * 60 + m;
    };
    return Math.max(1, Math.ceil(toMin(endTime) - toMin(startTime)));
}
function withMeetings(items, isoDate, meetingIdBase) {
    return items.map(function (item, itemIdx) { return ({
        startTime: item.startTime,
        endTime: item.endTime,
        count: item.titles.length,
        meetings: item.titles.map(function (title, ti) { return ({
            date: isoDate,
            title: title,
            durationMinutes: barDurationMinutes(item.startTime, item.endTime),
            meetingId: meetingIdBase + itemIdx * 20 + ti,
            startTime: item.startTime,
            endTime: item.endTime
        }); })
    }); });
}
var mockMeetingsData = [
    [
        {
            startTime: '09:00:00',
            endTime: '10:00:00',
            titles: ['Weekly team sync']
        },
        {
            startTime: '09:00:00',
            endTime: '10:00:00',
            titles: ['Hiring interview', '1:1 with manager']
        },
        {
            startTime: '13:00:00',
            endTime: '14:00:00',
            titles: ['Product review', 'Roadmap planning', 'Client call']
        }
    ],
    [
        {
            startTime: '09:00:00',
            endTime: '10:00:00',
            titles: ['Design review', 'Quarterly planning']
        },
        {
            startTime: '09:00:00',
            endTime: '10:00:00',
            titles: ['Design review']
        },
        {
            startTime: '14:00:00',
            endTime: '15:00:00',
            titles: ['Customer discovery', 'Demo prep']
        },
        {
            startTime: '16:00:00',
            endTime: '17:00:00',
            titles: ['Retrospective', 'Sprint planning', 'Architecture sync']
        }
    ],
    [
        {
            startTime: '09:00:00',
            endTime: '10:00:00',
            titles: ['Ops sync', 'Ops sync', 'Ops sync']
        },
        {
            startTime: '09:10:00',
            endTime: '10:00:00',
            titles: ['Tech debt grooming']
        },
        {
            startTime: '09:20:00',
            endTime: '10:00:00',
            titles: ['Incident review', 'Security check']
        },
        {
            startTime: '15:00:00',
            endTime: '15:20:00',
            titles: ['Vendor call']
        },
        {
            startTime: '15:05:00',
            endTime: '15:20:00',
            titles: ['Partner sync', 'Legal review']
        }
    ],
    [
        {
            startTime: '08:00:00',
            endTime: '09:00:00',
            titles: ['Morning standup']
        },
        {
            startTime: '08:00:00',
            endTime: '09:00:00',
            titles: ['Morning standup', 'Delivery sync', 'Infra planning']
        },
        {
            startTime: '12:00:00',
            endTime: '13:00:00',
            titles: ['Lunch & learn', 'Community call']
        }
    ],
    [
        {
            startTime: '09:00:00',
            endTime: '10:00:00',
            titles: ['Team update', 'Client handoff']
        },
        {
            startTime: '09:10:00',
            endTime: '10:00:00',
            titles: ['Product check-in']
        },
        {
            startTime: '09:20:00',
            endTime: '10:00:00',
            titles: ['QA triage', 'Bug bash']
        },
        {
            startTime: '15:00:00',
            endTime: '15:20:00',
            titles: ['Sales sync']
        },
        {
            startTime: '15:05:00',
            endTime: '15:20:00',
            titles: ['Renewal review', 'Pricing discussion']
        }
    ],
    [
        {
            startTime: '10:00:00',
            endTime: '11:00:00',
            titles: ['Monthly all-hands']
        },
        {
            startTime: '12:00:00',
            endTime: '13:00:00',
            titles: ['Mentoring session', 'Peer feedback']
        },
        {
            startTime: '14:00:00',
            endTime: '15:00:00',
            titles: ['Stakeholder update', 'UX review', 'Backlog grooming']
        }
    ]
];
export var meetingsByTimePeriod = function (input) {
    var interval = getInterval(input.dateFrom, input.dateTo);
    var dateFrom = startOfDay(input.dateFrom);
    var dateTo = endOfDay(input.dateTo);
    var periods = groupByPeriod([], dateFrom, dateTo, interval);
    var demoRangeStart = startOfDay(new Date(input.dateFrom));
    var periodBounds = getPeriodDateBoundsForInterval(interval, dateFrom, dateTo);
    return periods.map(function (period, idx) {
        var _a, _b, _c, _d;
        return ({
            period: period.date,
            periodDateFrom: (_b = (_a = periodBounds[idx]) === null || _a === void 0 ? void 0 : _a.periodDateFrom) !== null && _b !== void 0 ? _b : format(dateFrom, 'yyyy-MM-dd'),
            periodDateTo: (_d = (_c = periodBounds[idx]) === null || _c === void 0 ? void 0 : _c.periodDateTo) !== null && _d !== void 0 ? _d : format(dateTo, 'yyyy-MM-dd'),
            items: withMeetings(mockMeetingsData[idx % mockMeetingsData.length] || [], format(addDays(demoRangeStart, idx), 'yyyy-MM-dd'), 50000 + idx * 500)
        });
    });
};
